import type { ServerResponse } from '@onhandtech/onhand-fe-shared/lib/api/v4/requests/post-patch-request-by-id'
import { addNotification } from '@onhandtech/onhand-fe-shared/lib/notifications'
import type { ReduxModuleResultPayloadAction } from '@onhandtech/onhand-fe-shared/lib/redux'
import {
  autoEnrollSelector,
  patchRequestTypeSelector,
  selectedRequestSelector,
} from 'redux/ayom/missions/selectors'
import { call, put, select } from 'redux-saga/effects'

import { createSessionSaga } from '../../../../ayom/missions/sagas/create-session.saga'

export function* handlePatchSuccessSaga({
  formatMessage,
}: ReduxModuleResultPayloadAction<ServerResponse>) {
  const selectedRequest = yield select(selectedRequestSelector)
  const patchRequestType = yield select(patchRequestTypeSelector)
  if (formatMessage) {
    yield put(
      addNotification({
        id: `patch-${patchRequestType}-success`,
        variant: 'success',
        title: formatMessage({
          id: `page.missions.notification.success.${patchRequestType}.title`,
        }),
        description: formatMessage({
          id: `page.missions.notification.success.${patchRequestType}.desc`,
        }),
      }),
    )
  }
  const shouldAutoEnroll = yield select(autoEnrollSelector)
  if (selectedRequest?.volunteer && shouldAutoEnroll) {
    yield call(createSessionSaga, {
      matchedVolunteerId: selectedRequest.volunteer.id,
      parentRequestId: selectedRequest.id,
    })
  }
}
